module.exports = __webpack_public_path__ + "img/71.72eecc4a.svg";